import React, { Component } from 'react';
// ui
import { Icon } from 'rmwc/Icon';
import { Typography } from 'rmwc/Typography';
import { Button } from 'rmwc/Button';
// styles
import './soldier_styles.css';
import { TO_DATE_TEXT } from "./Timeline";
import Photo from "./Photo";

class Soldier extends Component {

    constructor(props) {
        super(props);

        this.state = { biogIsOpen: props.openBiog };
    }

    componentDidUpdate(prevProps) {
        if (this.state.biogIsOpen !== this.props.openBiog && this.props.openBiog !== prevProps.openBiog) {
            this.setState({ biogIsOpen: this.props.openBiog })
        }
    }

    render() {
        const { data } = this.props;

        const { photo, firstname, middlenames, dateKilled, lastname, agedied, house, street, town, regiment, biog, news } = data;

        let address = `${house ? house : ''} ${street ? street + ',' : ''} ${town ? town : ''}`;

        const soldierName = `${firstname ? firstname : ''} ${middlenames ? middlenames : ''} ${lastname ? lastname : ''}`;
        const ageText = agedied ? agedied : '??';

        const dateKilledStr = dateKilled === null ? "unknown" : TO_DATE_TEXT(dateKilled);

        let formattedNews = null;

        if (news) {
            formattedNews = news.split('\n').join('<br />');
            formattedNews = formattedNews.split('\r').join('<br />');
        }

        return (
            <div className={'soldier--holder'}>
                <div className={'soldier'}>
                    <div className={'soldier--picturePanel'}>
                        <img src={'./white-cross.png'} alt={'white cross'}/>

                        <Typography use={'overline'}
                                    tag={'div'}
                                    className={'soldier--age'}>
                            Age {ageText}
                        </Typography>

                    </div>

                    <div className={'soldier--detailsPanel'}>
                        <Typography use={'headline6'} tag={'span'}>
                            {soldierName}
                            {photo &&
                            <Icon icon="photo_camera"
                                  style={{ verticalAlign: 'middle', marginLeft: 5 }}/>
                            }
                        </Typography>

                        <Typography use={'caption'}
                                    tag={'span'}>Died: {dateKilledStr}</Typography>

                        {(house || street || town) &&
                        <Typography use={'caption'}
                                    tag={'div'}>{address}</Typography>
                        }
                        <Typography use={'body2'}
                                    className={'soldier--regiment'}
                                    tag={'div'}>
                            {regiment}
                        </Typography>

                        {biog &&
                        <Button dense
                                onClick={() => this.setState({ biogIsOpen: !this.state.biogIsOpen })}>
                            {`${this.state.biogIsOpen ? 'less' : 'more'} info`}
                        </Button>
                        }

                    </div>

                </div>

                {this.state.biogIsOpen &&
                <div className={'soldier--biog'}>

                    {photo &&
                    photo.map(photoFileName => <Photo root={'./soldiers/'}
                                                      img={`${photoFileName}`}
                                                      key={photoFileName}/>)
                    }

                    <Typography use={'body1'} tag={'p'}
                                className={'soldier--biog--text'}>{biog}</Typography>

                    {formattedNews &&
                    <Typography use={'body1'} tag={'p'}
                        className={'soldier--biog--text'}
                        dangerouslySetInnerHTML={{ __html: formattedNews }}
                    />
                    }
                </div>
                }
            </div>
        )
    }
}

export default Soldier;


// WEBPACK FOOTER //
// ./src/app/components/Soldier.js